import { render, staticRenderFns } from "./fwsed-overview-section.vue?vue&type=template&id=99c66d70&scoped=true&"
import script from "./fwsed-overview-section.vue?vue&type=script&lang=js&"
export * from "./fwsed-overview-section.vue?vue&type=script&lang=js&"
import style0 from "./fwsed-overview-section.vue?vue&type=style&index=0&id=99c66d70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c66d70",
  null
  
)

export default component.exports